import { render } from "./GalleryPagination.vue?vue&type=template&id=40359649&scoped=true"
import script from "./GalleryPagination.vue?vue&type=script&lang=js"
export * from "./GalleryPagination.vue?vue&type=script&lang=js"

import "./GalleryPagination.vue?vue&type=style&index=0&id=40359649&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40359649"]])

export default __exports__